import { render } from "./CartReminderBanner.vue?vue&type=template&id=4911adac&scoped=true"
import script from "./CartReminderBanner.vue?vue&type=script&lang=js"
export * from "./CartReminderBanner.vue?vue&type=script&lang=js"

import "./CartReminderBanner.vue?vue&type=style&index=0&id=4911adac&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4911adac"]])

export default __exports__